const o = () => {
  if (typeof document > "u")
    return;
  const e = document.cookie.match(RegExp("(?:^|;\\s*)cmapi_cookie_privacy=([^;]*)"));
  return e ? e[1] : void 0;
};
export {
  o as default
};
